import { CopyButton } from '@shared/components/copy-button/CopyButton';
import * as React from 'react';

import type { InvoiceNumberCellProps } from './InvoiceNumberCell.types';

import styles from './InvoiceNumberCell.module.css';

const InvoiceNumberCell = React.memo(
  ({ value }: Readonly<InvoiceNumberCellProps>): React.ReactElement => {
    return (
      <span
        className={styles.invoiceNumberCell}
        data-testid="invoice-number-cell"
        role="group"
        aria-label={`Invoice number ${value}. Press Tab or hover to reveal copy button`}
        tabIndex={0}
      >
        <span className={styles.valueText}>{value}</span>
        <CopyButton value={value} ariaLabel={`Copy invoice number ${value}`} />
      </span>
    );
  }
);

InvoiceNumberCell.displayName = 'InvoiceNumberCell';

export { InvoiceNumberCell };
